import SubmissionList from './List'
export default SubmissionList
